module.exports = __webpack_public_path__ + "img/pauseBtn.130ad5ca.svg";